var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 90,
    viewBox: "0 0 80 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EF504E",
    fillRule: "nonzero",
    strokeWidth: 3.75,
    d: "M39.87 87.5L21.554 74.19A45.75 45.75 0 0 1 2.706 38.055l-.534-27.927c21.2 0 33.765-2.63 37.693-7.888 4.086 5.258 16.657 7.888 37.713 7.888l-.533 27.923a45.75 45.75 0 0 1-18.853 36.14L39.87 87.5z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.044 32.236l19.707 19.891M49.843 32.373L29.952 52.08"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotVerified);
export default __webpack_public_path__ + "static/media/not_verified.31989bde7e0886de0dcbb8fdfc84e302.svg";
export { ForwardRef as ReactComponent };